export default "__VITE_ASSET__Ccpmbm34__"